import styled from "@emotion/styled";
import { genericStyles } from "../../../constant";

export const TeamContainer = styled.div`
  min-height: 80dvh;
  .team-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 16px;

    .team-card {
      border-radius: 16px;
      padding: 0px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: none;
      overflow: hidden;
      background: white;

      &:hover {
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
        transform: translateY(-8px);
      }

      .ant-card-body {
        padding: 16px;
      }
    }
  }

  .card-header {
    background: linear-gradient(135deg, #e0f2fe 0%, #ede9fe 100%);
    padding: 20px 24px;
    border-radius: 10px;

    .team-name {
      color: #1e293b; // slate-800 (professional dark text)
      font-size: 20px;
      font-weight: 600;
      margin: 0 0 8px 0;
    }

    .branch-tag {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: rgba(30, 41, 59, 0.08); // subtle dark overlay
      color: #334155; // slate-700
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
    }
  }

  .leader-section {
    margin-top: 16px;
    border-radius: 12px;
    margin-bottom: 16px;

    .leader-header {
      display: flex;
      align-items: center;
      gap: 12px;

      .leader-info {
        flex: 1;

        .name {
          font-weight: 500;
          color: #1a1a1a;
          margin: 0;
          font-size: 15px;
        }

        .role-tag {
          font-size: 12px;
          color: #667eea;
          font-weight: 500;
        }
      }
    }
  }

  .topic-section {
    margin-bottom: 20px;

    .topics-label {
      font-weight: 500;
      color: #666;
      margin-bottom: 10px;
      display: block;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .ant-tag {
      margin: 0 6px 6px 0;
      border-radius: 8px;
      padding: 4px 10px;
      font-size: 12px;
      border: none;
      font-weight: 500;
    }
  }

  .action-section {
    display: flex;
    gap: 8px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;

    button {
      flex: 1;
      height: 36px;
      border-radius: 8px;
      font-weight: 500;
      font-size: 13px;
    }

    .view-btn {
      background: #f8f9fa;
      color: ${genericStyles.primaryColor};
      border: 1px solid #e8e8e8;

      &:hover {
        background: ${genericStyles.primaryColor} !important;
        color: white !important;
      }
    }
  }

  .team-state {
    text-align: center;
    padding: 80px 20px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

    .empty-icon {
      font-size: 64px;
      color: #d9d9d9;
      margin-bottom: 16px;
    }

    .empty-text {
      font-size: 18px;
      color: #666;
      margin-bottom: 24px;
    }
  }
`;
